import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Welcome() {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');

  useEffect(() => {
    // Clear the HBR unique ID when loading the welcome page
    localStorage.removeItem('hbrUniqueId');
  }, []);

  const getButtonConfig = () => {
    if (userRole === 'HBR & Scanning') {
      return {
        text: 'HBR & Scanning',
        backgroundColor: '#1976d2',
        navigateTo: '/consent'
      };
    } else {
      return {
        text: 'Eligibility Check',
        backgroundColor: '#2e7d32',
        navigateTo: '/questions'
      };
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <div style={{
      maxWidth: 400,
      margin: 'auto',
      padding: 20,
      backgroundColor: '#f0f0f5',
      borderRadius: 10,
      fontFamily: "'Arial Black', Arial, sans-serif",
      color: '#000',
      textAlign: 'center',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)'
    }}>
      <img
        src="/arl-logo.png"
        alt="ARL Aviation Services Logo"
        style={{ width: '100%', maxWidth: 250, marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
      />
      <h3 style={{ fontWeight: 'bold', marginBottom: 20, fontFamily: "'Arial Black', Arial, sans-serif", fontSize: 24, color: '#000' }}>
        {buttonConfig.text}
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
        <button
          onClick={() => navigate(buttonConfig.navigateTo)}
          style={{
            backgroundColor: buttonConfig.backgroundColor,
            color: 'white',
            fontWeight: 'bold',
            fontSize: 18,
            padding: '10px 20px',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
            width: '100%'
          }}
        >
          {buttonConfig.text}
        </button>
        <button
          onClick={() => {
            localStorage.removeItem('userRole');
            localStorage.removeItem('token');
            navigate('/login');
          }}
          style={{
            backgroundColor: '#d32f2f',
            color: 'white',
            fontWeight: 'bold',
            fontSize: 16,
            padding: '8px 16px',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            width: '100%',
            marginTop: 10
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default Welcome;
